import { APP_COLORS, APP_FONT_FAMILIES } from "../enums";

const customMuiAlert: any = {
  styleOverrides: {
    root: {
      borderRadius: 16,
      fontWeight: 500,
      fontFamily: APP_FONT_FAMILIES.ibmPlexMono,
      fontSize: 12,
      lineHeight: "16px",
      letterSpacing: "0",
    },
  },
  variants: [
    {
      props: { severity: "info" },
      style: {
        backgroundColor: APP_COLORS.infoLight2,
        color: APP_COLORS.infoDark4,
        border: `1px solid ${APP_COLORS.infoLight4}`,
      },
    },
    {
        props: { severity: "error" },
        style: {
            backgroundColor: APP_COLORS.errorLight2,
            color: APP_COLORS.errorDark4,
            border: `1px solid ${APP_COLORS.errorLight4}`,
        },
    },
    {
        props: { severity: "warning" },
        style: {
            backgroundColor: APP_COLORS.yellowLight2,
            color: APP_COLORS.yellowDark4,
            border: `1px solid ${APP_COLORS.yellowLight4}`,
        },
    },
    {
        props: { severity: "success" },
        style: {
            backgroundColor: APP_COLORS.successLight2,
            color: APP_COLORS.successDark4,
            border: `1px solid ${APP_COLORS.successLight4}`,
        },
    },
    {
        props: { severity: "default" },
        style: {
            backgroundColor: APP_COLORS.greyLight2,
            color: APP_COLORS.greyDark4,
            border: `1px solid ${APP_COLORS.greyLight4}`,
        },
    },
  ],
};

export { customMuiAlert };
